<template>
  <common-filter
    :title="$t('filter.sessionFilters')"
    @confirm="confirmFilter"
    @cancel="clearFilter"
    @open:filter="openFilterHandler"
  >
    <div class="filter-group">
      <label class="filter-label">{{ $t('general.searh') }}:</label>
      <base-reset-button v-if="localPerson.id" v-model="localPerson.id"></base-reset-button>
      <person-search-filter
        :id="localPerson.id"
        :find-by="person.findBy"
        @select:item="selectPerson"
      ></person-search-filter>
    </div>
    <div class="filter-group filter-group-flex">
      <div class="filter-group__part filter-group__part_lg">
        <label class="filter-label">{{ $t('general.date') }}</label>
        <base-reset-button v-if="localDates.startDate" @input="clearDates"></base-reset-button>
        <base-calendar-wrap>
          <range-calendar
            :start-date="localDates.startDate"
            :end-date="localDates.endDate"
            @input="changeDates"
          ></range-calendar>
        </base-calendar-wrap>
      </div>
      <div class="filter-group__part">
        <label class="filter-label">{{ $t('general.id') }}:</label>
        <base-reset-button v-if="localId" v-model="localId"></base-reset-button>
        <id-filter v-model.number="localId"></id-filter>
      </div>
    </div>
    <div class="filter-group">
      <label class="filter-label">{{ $t('filter.5092') }}</label>
      <base-reset-button v-if="localStatuses.length" v-model="localStatuses"></base-reset-button>
      <status-filter v-model="localStatuses" :status-list="statusList"></status-filter>
    </div>
    <div class="filter-group">
      <label class="filter-label">{{ $t('filter.5091') }}</label>
      <base-reset-button v-if="localTypes.length" v-model="localTypes"></base-reset-button>
      <status-filter v-model="localTypes" :status-list="typeList"></status-filter>
    </div>

    <div class="filter-group">
      <label class="filter-label">{{ $t('filter.9867') }}</label>
      <base-reset-button v-if="localComments" v-model="localComments"></base-reset-button>
      <base-textarea name="interpretation" v-model="localComments"></base-textarea>
    </div>

    <div class="filter-group">
      <label class="filter-label">{{ $t('sessionsInfo.events') }}:</label>
      <base-reset-button v-if="localEvents.length" v-model="localEvents"></base-reset-button>
      <cardio-events-filter v-model="localEvents"></cardio-events-filter>
    </div>
  </common-filter>
</template>

<script>
import { sessionStatusListForTrainingTable, sessionTypeList } from '@/modules/status-list.js'
import { courseSessionCommon } from '@/components/Filters/mixins/couse-session-common-part.js'

export default {
  name: 'PageSessionFilter',
  mixins: [courseSessionCommon],
  components: {
    CardioEventsFilter: () => import('@/components/Filters/CardioEventsFilter.vue'),
    BaseTextarea: () => import('@/base/BaseTextarea.vue')
  },
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    localEvents: [],
    localComments: null,
    localTypes: []
  }),
  mounted() {
    if (this.events) {
      this.localEvents = this.events.slice()
    }
  },
  computed: {
    statusList() {
      return sessionStatusListForTrainingTable
    },
    typeList() {
      return sessionTypeList
    }
  },
  methods: {
    confirmFilter() {
      this.$emit('confirm', {
        trainingId: this.localId,
        person: this.localPerson,
        statuses: this.localStatuses,
        types: this.localTypes,
        dates: {
          startDate: this.localDates.startDate ? this.moment(this.localDates.startDate) : null,
          endDate: this.localDates.endDate ? this.moment(this.localDates.endDate) : null
        },
        events: this.localEvents,
        comments: this.localComments
      })
    },
    clearFilter() {
      this.localPerson = { id: null }
      this.localId = null
      this.localStatuses = []
      this.localDates.startDate = null
      this.localDates.endDate = null
      this.localEvents = []
      this.localComments = null
      this.localTypes = []
    },
    openFilterHandler() {
      this.$metrika.reachGoal('OPEN_SESSIONS_FILTER')
    }
  }
}
</script>
